:host {
  position: relative;

  ::slotted([slot="preview-logo"]) {
    width: 100%;
  }

  ::slotted([slot="preview-image"]) {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  ::slotted([slot="cookiewall-text"]) {
    margin: 0;

    p {
      margin: 0;

      &:not(:last-child) {
        @include spaceCurve('margin-bottom', 'small');
      }
    }
  }
}

.stzh-iframe {
  width: 100%;
  height: 100%;

  &__iframe {
    width: 100%;
  }

  &__cookiewall,
  &__preview {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &__iframe,
  &__preview {
    border: none;
  }

  &__preview,
  &__cookiewall {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: space('medium');
    visibility: hidden;

    &.is-visible {
      visibility: visible;
    }
  }

  &__preview {
    z-index: 1;
    appearance: none;
    cursor: pointer;
    background-color: $colorGrey20;
  }

  &__preview-image-wrapper:not(:empty) + &__preview-logo-wrapper {
    display: none;
  }

  &__preview-logo-wrapper {
    @include spaceCurve('top', 'medium');
    @include spaceCurve('left', 'medium');
    position: absolute;
    width: 45%;
  }

  &__preview-run {
    position: relative;
    z-index: 1;
    appearance: none;
    border: none;
    background-color: $colorPrimary;
    color: $colorWhite;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: $formInputHeightSmall;
    height: $formInputHeightSmall;
    visibility: hidden;
    transition: background-color $baseTransitionAnimationSpeed;

    &.is-visible {
      visibility: visible;
    }

    @include mq($from: medium) {
      width: $formInputHeight;
      height: $formInputHeight;
    }
  }

  &__preview:hover &__preview-run {
    background-color: $colorSecondary60;
  }

  &__preview-run-icon {
    @include mq($from: medium) {
      --size: #{iconSize('large')};
    }
  }

  &__cookiewall {
    @include spaceCurve('padding-left', 'regular');
    @include spaceCurve('padding-right', 'regular');
    z-index: 2;
    text-align: center;
    background-color: $colorBlack60op;
    color: $colorWhite;

    @include mq($from: medium) {
      @include gridGutter;
      display: grid;
      grid-template-areas: ". content content content content content content .";
      grid-template-columns: repeat(8, minmax(0, 1fr));
      padding-left: 0;
      padding-right: 0;
    }
  }

  &__cookiewall-content {
    @include mq($from: medium) {
      grid-area: content;
    }
  }

  &__cookiewall-text {
    @include fontSize('milli');
    @include spaceCurve('padding-top', 'small');
    @include spaceCurve('padding-bottom', 'small');
    @include spaceCurve('margin-bottom', 'regular');
  }

  &__cookiewall-close {
    top: 0;
    right: 0;
    position: absolute;
    appearance: none;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: space('xsmall');
    background-color: transparent;
    color: $colorWhite;
    cursor: pointer;
  }
}
